import type { DurationInMinutes } from "@@/shared/date-time/time-spans";
import { z } from "zod";
import type { ProviderId} from "../provider-id";
import { providerIdZodSchema } from "../provider-id";

type ProviderSetPrepTimeCommand = {
    _type: "PROVIDER_SET_PREP_TIME_COMMAND";
    providerId: ProviderId;
    prepTime: DurationInMinutes;
};

const providerSetPrepTimeCommandZodSchema: z.ZodSchema<ProviderSetPrepTimeCommand> =
    z.object({
        _type: z.literal("PROVIDER_SET_PREP_TIME_COMMAND"),
        providerId: providerIdZodSchema,
        prepTime: z
            .number()
            .min(0)
            .int() as unknown as z.ZodType<DurationInMinutes>,
    });

export { providerSetPrepTimeCommandZodSchema };
export type { ProviderSetPrepTimeCommand };
